import { Tooltip } from "@mui/material";
import React from "react";

export default function CustomTooltip({ children, title, placement }) {
  return (
    <Tooltip placement={placement} title={title}>
      {children}
    </Tooltip>
  );
}
